import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { MdContentCopy } from 'react-icons/md';
import Select from 'react-select';
import './ModuleCode.scss';


function ModuleCode(props) {
  const [copiedZip, setCopiedZip] = useState(false);
  const [copiedJar, setCopiedJar] = useState(false);

  const splitGroup = (pkg) => {
    const javaPackage = pkg.split('.');
    return javaPackage[0].concat('.').concat(javaPackage[1]);
  };
  const splitArtifact = (pkg) => {
    const javaPackage = pkg.split('.');
    return javaPackage.slice(2).join('.');
  };

  let group, artifact;
  if (props.javaPackage) {
    group = splitGroup(props.javaPackage);
    artifact = splitArtifact(props.javaPackage);
  }
  // Previous logic for localization.spain differentiation:
  // const [selectedCoreVersion, setSelectedCoreVersion] = useState(
  //   props.javaPackage && props.javaPackage.includes('localization.spain') ? '24.x' : '25.x'
  // );
  const [selectedCoreVersion, setSelectedCoreVersion] = useState('26.x');
  let versionRange;
  switch (selectedCoreVersion) {
    case '24.x':
      versionRange = '[1.0.0,3.0.0)';
      break;
    case '25.x':
      versionRange = '[3.0.0,4.0.0)';
      break;
    case '26.x':
      versionRange = '[4.0.0,5.0.0)';
      break;
    default:
      versionRange = '[4.0.0,5.0.0)';
      break;
  }

  if (artifact.includes('es_es')){
    versionRange = '[1.0.0,)';
  }
  const codeZip = `moduleDeps('${group}:${artifact}:${versionRange}@zip'){ transitive = true }`;
  const codeJar = `implementation('${group}:${artifact}:${versionRange}')`;

  return (
    <>
      {artifact && !artifact.includes('es_es') && (
        <>
          <div className='title-install'>Etendo Version</div>
          {/* Previous logic for localization.spain differentiation:
          <Select
            classNamePrefix="core-version"
            value={{ value: selectedCoreVersion, label: selectedCoreVersion }}
            options={
              artifact.includes('localization.spain')
                ? [{ value: '24.x', label: '24.x' }]
                : [
                    { value: '25.x', label: '25.x' },
                    { value: '24.x', label: '24.x' }
                  ]
            }
            onChange={(option) => setSelectedCoreVersion(option.value)}
          />
          */}
          <Select
            classNamePrefix="core-version"
            value={{ value: selectedCoreVersion, label: selectedCoreVersion }}
            options={[
              { value: '26.x', label: '26.x' },
              { value: '25.x', label: '25.x' },
              { value: '24.x', label: '24.x (deprecated)' }
            ]}
            onChange={(option) => setSelectedCoreVersion(option.value)}
          />
        </>
      )}
      <br />
      <div className='title-install'>Source Code Format</div>
      <code className='codeCard'>
        <div className='d-flex flex-row justify-content-end'>
          <CopyToClipboard text={codeZip} onCopy={() => {
            setCopiedZip(true);
            setTimeout(() => setCopiedZip(false), 2000);
          }}>
            {copiedZip ? (
              <div className='copied'>Copied!</div>
            ) : (
              <MdContentCopy className='copied' size={15} />
            )}
          </CopyToClipboard>
        </div>
        {codeZip}
      </code>
      <br />
      <div className='title-install'>JAR Format</div>
      <code className='codeCard'>
        <div className='d-flex flex-row justify-content-end'>
          <CopyToClipboard text={codeJar} onCopy={() => {
            setCopiedJar(true);
            setTimeout(() => setCopiedJar(false), 2000);
          }}>
            {copiedJar ? (
              <div className='copied'>Copied!</div>
            ) : (
              <MdContentCopy className='copied' size={15} />
            )}
          </CopyToClipboard>
        </div>
        {codeJar}
      </code>
    </>
  );
}

export default ModuleCode;
